import storage from 'root/common/util/storage';
import { initSourceChannelParams } from 'root/common/thirdParty/utils';
import { CHANNEL_MAP } from 'root/common/thirdParty/const/channel';

class PrivilegeState {
    constructor() {
        this.init();
    }

    init() {
        initSourceChannelParams();
    }

    static get() {
        return storage.get(storage.keys['privilegeSourceChannel']);
    }

    static getAll() {
        const channel = PrivilegeState.get();
        const result = [];
        if (!channel) return result;

        result.unshift(channel);

        PrivilegeState.mapParent(channel, result.unshift.bind(result));

        return result;
    }

    static isBelongToChannel(channel, parentChannel) {
        if (!channel) return false;
        if (channel === parentChannel) return true;
        let result = false;

        PrivilegeState.mapParent(channel, parent => {
            if (!result && parent === parentChannel) {
                result = true;
            }
        });

        return result;
    }

    static mapParent(channel, fn) {
        const channelData = CHANNEL_MAP[channel];

        if (!channelData) return;

        let parent = channelData.parent;

        while (parent) {
            fn.call(null, parent);
            parent = CHANNEL_MAP[parent].parent;
        }
    }

    static isChannel(channel, targetName) {
        return channel === targetName;
    }

    static inject(param) {
        let privilegeSourceChannel = storage.get(storage.keys['privilegeSourceChannel']);
        let privilegeSourceChannelSign = storage.get(storage.keys['privilegeSourceChannelSign']);
        if (privilegeSourceChannel) param.sourceChannel = privilegeSourceChannel;
        if (privilegeSourceChannelSign) param.sourceChannelSign = privilegeSourceChannelSign;
        return param;
    }
}

export default PrivilegeState;
